module.exports = __webpack_public_path__ + "img/jrzctp.01b6c40a.png";